import { ajaxRequest } from '../utils/helpers';
import './sitemap.scss';

const { siteMapUrl } = window.inlineSiteMap;

const markupParent = document.querySelector('.sitemap__wrapper');

ajaxRequest('GET', siteMapUrl).then(
  data => {
    const { sitemaps } = data;

    const markupWrapper = document.createElement('div');
    markupWrapper.classList.add('row', 'sitemap__category-row');

    sitemaps.forEach(category => {
      const sitemapCategory = document.createElement('div');
      sitemapCategory.classList.add('sitemap__category-row-item');
      const sitemapHeading = document.createElement('h2');
      sitemapHeading.classList.add('sitemap__heading');
      const sitemapHeadingText = document.createTextNode(category.type);

      markupWrapper.appendChild(sitemapCategory);
      sitemapCategory.appendChild(sitemapHeading);
      sitemapHeading.appendChild(sitemapHeadingText);

      const categoryList = document.createElement('ul');
      categoryList.classList.add('sitemap__list');
      sitemapCategory.appendChild(categoryList);

      category.urlset.item.forEach(item => {
        const categoryListItem = document.createElement('li');
        const categoryListItemLink = document.createElement('a');
        categoryListItemLink.setAttribute('href', item.url);
        const categoryListItemText = document.createTextNode(item.name);

        if (item.name) {
          categoryList.appendChild(categoryListItem);
          categoryListItem.appendChild(categoryListItemLink);
          categoryListItemLink.appendChild(categoryListItemText);
        }
      });
    });

    markupParent.appendChild(markupWrapper);
  },
  () => {
    const errorMessage = document.querySelector('.sitemap__error-message').innerText.trim();
    const errorHeading = document.createElement('h1');
    errorHeading.classList.add('sitemap__error-heading');
    const errorHeadingText = document.createTextNode(errorMessage);
    errorHeading.appendChild(errorHeadingText);
    markupParent.appendChild(errorHeading);
  }
);
